
import { supabase } from '@/lib/supabase'
import { createOrganizationForNewUser } from './organization/createOrganization'
import { formatUserPhoneNumber } from './organization/phoneUtils'

export const signUp = async (email: string, password: string, metadata?: any) => {
  console.log('Tentative d\'inscription:', email)
  console.log('Métadonnées utilisateur:', metadata)
  
  try {
    // Prepare user metadata with special attention to phone
    const userMetadata: Record<string, any> = {};
    
    if (metadata) {
      if (metadata.full_name) userMetadata.full_name = metadata.full_name;
      if (metadata.phone_number) {
        // Formater le numéro de téléphone pour s'assurer qu'il est au bon format
        userMetadata.phone = formatUserPhoneNumber(metadata.phone_number);
        console.log('Numéro de téléphone formaté ajouté aux métadonnées:', userMetadata.phone);
      }
    }
    
    console.log('Métadonnées préparées pour l\'authentification:', userMetadata);
    
    // Register with metadata included in the initial sign up
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: userMetadata
      }
    })
    
    if (error) {
      console.error('Erreur lors de l\'inscription:', error)
      throw error
    }
    
    console.log('Inscription réussie:', data)
    console.log('Métadonnées de l\'utilisateur après inscription:', data.user?.user_metadata)
    
    // Create organization with enterprise plan by default
    if (metadata && metadata.organization && data.user) {
      try {
        await createOrganizationForNewUser(data.user.id, metadata);
      } catch (orgError) {
        console.error('Erreur lors de la création de l\'organisation:', orgError);
        // Continue with signup even if organization creation fails
      }
    }
    
    return { data, error: null }
  } catch (error) {
    console.error('Exception lors de l\'inscription:', error)
    return { data: null, error }
  }
}
